import React, { useState, useRef, lazy } from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
const videos = ['https://cdn.magicpatterns.com/uploads/imKqbMdMdZbhhJv1qekFBv/IMG_4205.MOV', 'https://cdn.magicpatterns.com/uploads/78C5cn7utrQKWP7ijeUnEC/WhatsApp Video 2026-03-08 at 13.10.55.mp4'];
function VideoPlayer({
  src
}: {
  src: string;
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef<HTMLVideoElement>(null);
  const handlePlay = () => {
    if (!isLoaded) {
      setIsLoaded(true);
      setIsPlaying(true);
      return;
    }
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };
  return <div className="relative aspect-[9/16] bg-black rounded-xl sm:rounded-2xl overflow-hidden shadow-lg group cursor-pointer w-full max-w-sm mx-auto" onClick={handlePlay} data-id="element-178">
      {!isLoaded ? <>
          <video src={`${src}#t=0.1`} className="w-full h-full object-cover opacity-70" playsInline preload="metadata" muted data-id="element-179" />
          <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-180">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/90 rounded-full flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform" data-id="element-181">
              <PlayIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#FF6B8A] ml-1" data-id="element-182" />
            </div>
          </div>
        </> : <video ref={videoRef} src={src} className="w-full h-full object-cover" playsInline loop autoPlay onEnded={() => setIsPlaying(false)} onPause={() => setIsPlaying(false)} onPlay={() => setIsPlaying(true)} data-id="element-183" />}

      {isLoaded && !isPlaying && <div className="absolute inset-0 bg-black/30 group-hover:bg-black/40 transition-colors flex items-center justify-center" data-id="element-184">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-white/90 rounded-full flex items-center justify-center shadow-xl transform group-hover:scale-110 transition-transform" data-id="element-185">
            <PlayIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#FF6B8A] ml-1" data-id="element-186" />
          </div>
        </div>}
    </div>;
}
export function VideoProofSection() {
  return <section className="py-10 md:py-14 px-4 bg-[#F5F0FF]" data-id="element-187">
      <div className="max-w-5xl mx-auto text-center" data-id="element-188">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="mb-8" data-id="element-189">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#2D2D3F] mb-3" data-id="element-190">
            Mirá por qué este pack encanta tanto
          </h2>
          <p className="text-base sm:text-lg text-[#6B7280] max-w-2xl mx-auto" data-id="element-191">
            Elegís el dibujo, lo imprimís y lo convertís en un momento creativo
            y divertido.
          </p>
        </motion.div>

        <div className="flex flex-col space-y-6 sm:space-y-8 max-w-md mx-auto" data-id="element-192">
          {videos.map((src, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} data-id="element-193">
              <VideoPlayer src={src} data-id="element-194" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}